module.exports = __webpack_public_path__ + "img/thunderstorm.c5c45740.jpg";